module.exports = __webpack_public_path__ + "static/media/watermark2.d208b824.png";